import { FileModel, FolderModel } from '../../../../../typings/api/skymap/rest/v1/.common';
import { Point2d } from '../../../viewer/utilities/math-helpers';

export enum EntityType {
  FILE,
  FOLDER,
}

export enum EntityStatus {
  CONFLICT,
  DONE,
  ERROR,
  PENDING,
  SKIP,
}

export interface DraggableItem {
  selectedEntities: EntityModel[];
  setTargetFolder: (targetFolder: { id: string | null; name: string; projectId?: string }) => void;
  dialog: {
    show: (pos?: Point2d | undefined) => void;
  };
}

export interface EntityModel {
  id: string;
  parentId: string | null;
  name: string;
  type: EntityType;
  status: EntityStatus;
}

export const combineFoldersFiles = (folders: FolderModel[], files: FileModel[]) => [
  ...files.map((file) => ({
    id: file.id,
    name: file.name,
    type: EntityType.FILE,
    parentId: file.folderId,
    status: EntityStatus.PENDING,
  })),
  ...folders.map((file) => ({
    id: file.id,
    name: file.name,
    type: EntityType.FOLDER,
    parentId: file.parentId,
    status: EntityStatus.PENDING,
  })),
];

const findAllAncestorFolders = (folderId: string, folders: FolderModel[]): FolderModel[] => {
  const folderMap = new Map(folders.map((folder) => [folder.id, folder]));

  const currentFolder = folderMap.get(folderId);

  if (!currentFolder) {
    throw new Error('Current folder must exist in the folder list');
  }

  if (!currentFolder.parentId) {
    return [];
  }

  const parentFolder = folderMap.get(currentFolder?.parentId);

  if (!parentFolder) {
    return [];
  }

  return [parentFolder].concat(findAllAncestorFolders(parentFolder.id, folders));
};

export const findAllAncestorFolderIds = (folderId: string, folders: FolderModel[]): string[] =>
  findAllAncestorFolders(folderId, folders).map((folder) => folder.id);
